import { ComputedRef, inject } from "vue";
import { Pool } from "@/models/pool.model";

export const useOut = () => inject("out") as ComputedRef<Pool["outs"][number]>;
